import { ECountry } from 'App/i18n/i18n.types';

export const BR_LANDING_PAGE_LINK =
  'https://www.nuvemshop.com.br/solucoes/nuvem-envio';

export const AR_LANDING_PAGE =
  'https://ayuda.tiendanube.com/es_ES/envio-nube/que-es-envio-nube-y-como-activarlo-en-mi-tienda';

export const MX_LANDING_PAGE =
  'https://ayuda.tiendanube.com/es_MX/envio-nube-mx/que-es-envio-nube-y-como-activarlo-en-mi-tienda';

export const NEW_LOCATION_ORIGIN = {
  APP_INSTALL: 'appInstall'
} as const;

type PriceExamples = {
  PRICE_BRANCH_SAME_CITY: number;
  PRICE_BRANCH_SAME_PROVINCE: number;
  PRICE_HOME_SAME_CITY: number;
};

export const PRICE_EXAMPLES: Record<ECountry, PriceExamples> = {
  [ECountry.MEXICO]: {
    PRICE_BRANCH_SAME_CITY: 109,
    PRICE_BRANCH_SAME_PROVINCE: 118,
    PRICE_HOME_SAME_CITY: 118
  },
  [ECountry.ARGENTINA]: {
    PRICE_BRANCH_SAME_CITY: 5020,
    PRICE_BRANCH_SAME_PROVINCE: 6230,
    PRICE_HOME_SAME_CITY: 7885
  },
  [ECountry.BRAZIL]: {
    PRICE_BRANCH_SAME_CITY: 10.09,
    PRICE_BRANCH_SAME_PROVINCE: 11.62,
    PRICE_HOME_SAME_CITY: 17.61
  }
};

export const TAGS_EXAMPLES: Record<ECountry, Record<string, string>> = {
  [ECountry.MEXICO]: {
    firstCard: 'branch',
    secondCard: 'branch',
    thirdCard: 'home'
  },
  [ECountry.ARGENTINA]: {
    firstCard: 'branch',
    secondCard: 'branch',
    thirdCard: 'home'
  },
  [ECountry.BRAZIL]: {
    firstCard: 'carrier-1',
    secondCard: 'carrier-2',
    thirdCard: 'carrier-3'
  }
};
